import React from 'react';
import TopBar from '../../components/layout/TopBar';
import Footer from '../../components/layout/Footer';
import useCustomServiceRequestForm from '../../hooks/useCustomServiceRequestForm';
import {
  RequestCustomServiceForm,
  RequestCustomServiceHeader,
  RequestCustomServiceTrustSection
} from './RequestCustomServiceSections';

const RequestCustomServicePage = ({ onNavigate }) => {
  const {
    formData,
    errors,
    isSubmitting,
    serviceTypes,
    timeSlots,
    durationOptions,
    participantOptions,
    budgetOptions,
    minDate,
    handleInputChange,
    handleSubmit
  } = useCustomServiceRequestForm({ onNavigate });

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* TopBar */}
      <TopBar 
        onLocationClick={(location) => console.log('Location clicked:', location)}
        onUserClick={() => onNavigate && onNavigate('login')}
        onCartClick={() => console.log('Cart clicked')}
        onLogoClick={() => onNavigate && onNavigate('home')}
      />

      <RequestCustomServiceHeader onNavigate={onNavigate} />
      <RequestCustomServiceForm
        onNavigate={onNavigate}
        formData={formData}
        errors={errors}
        isSubmitting={isSubmitting}
        serviceTypes={serviceTypes}
        timeSlots={timeSlots}
        durationOptions={durationOptions}
        participantOptions={participantOptions}
        budgetOptions={budgetOptions}
        minDate={minDate}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
      />
      <RequestCustomServiceTrustSection />
      
      <Footer />
    </div>
  );
};

export default RequestCustomServicePage;

